import { TFundAwardFormProps } from '../../model';

import { CheckTseMarket } from './CheckTseMarket';
import { ClubCheck } from './ClubCheck';
import { FundAwardForm } from './Form';

export const Mobile = ({
  form,
  onSubmit,
  isLoading,
  customerInfo,
  open,
  setOpen,
  data,
}: TFundAwardFormProps) => {
  const componentMap = {
    tseMarket: <CheckTseMarket />,
    club: <ClubCheck />,
    form: (
      <FundAwardForm
        form={form}
        onSubmit={onSubmit}
        isLoading={isLoading}
        open={open}
        setOpen={setOpen}
        data={data}
      />
    ),
  };

  const getComponentKey = (): keyof typeof componentMap => {
    if (!customerInfo?.isInTseMarket) return 'tseMarket';
    if (!customerInfo?.clubTotalRial) return 'club';
    return 'form';
  };

  return (
    <div className='w-screen h-full bg-background  pt-[calc(5px_+_var(--mobileHeaderHeight))]'>
      {componentMap[getComponentKey()]}
    </div>
  );
};
